<template>
	<div>
		<loading id="spinner" :active="loading" :can-cancel="false" :is-full-page="true"></loading>
		<h5>Ação</h5>
		<div class="row">
			<div class="input-field col s12 m12 l12 x12">
				<a :href="'/inscricaos/ver/' + rec.inscricao.id" target='_blank'>
					{{rec.inscricao.acao.titulo}}
				</a>
			</div>
		</div>

		<!--div>
			<div class="row">
				<div class="input-field col s12 m12 l12 x12">
					<label>Análise Técnica</label>
				</div>
			</div>
			<center>
				<table style='width: 70%;'>
					<col width="20%">
					<col width="80%">
					<thead>
						<tr>
							<th>Resultado</th>
							<th>Ações</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<span :class="rec.inscricao.analise_tecnica.resultado == 'habilitado'? 'new badge green' : 'new badge red'"
									  data-badge-caption="">
								{{ rec.inscricao.analise_tecnica.resultado.toUpperCase() }}</span>
							</td>
							<td>
								<a class="btn-floating btn-small blue lighten-1 tooltipped" :href="'/analises-tecnicas/' + rec.inscricao.id"
								   data-position="left"
								    data-tooltip='Visualizar análise'
									target='_blank'>
									<i class="material-icons white-text">visibility</i>
								</a>
								<a class="btn-floating btn-small grey darken-4 tooltipped"
                                   :disabled="!retornaSeInscricaoEstaHabilitadaParaTerAnaliseTecnicaEditada()"
								   style="pointer-events: auto !important;"
								   :href="retornaSeInscricaoEstaHabilitadaParaTerAnaliseTecnicaEditada() ? '/analises-tecnicas/' + rec.inscricao.id + '/edit' : null"
								   data-position="right"
								   data-tooltip='Editar análise'
								   target='_blank'>
								    <i class="material-icons white-text">edit</i>
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</center>
		</div-->

		<template v-if='rec.inscricao.avaliacaos.length'>
			<!--div class="row">
				<div class="input-field col s12 m12 l12 x12">
					<label>Avaliações</label>
				</div>
			</div-->
			<!--center-->
			<h5>Avaliações</h5>
				<table style='width: 20%;'>
					<!--col width="20%">
					<col width="80%">
					<thead>
						<tr>
							<th>Avaliações</th>
							<th>Avaliador</th>
						</tr>
					</thead-->
					<tbody>
						<tr v-for="(avaliacao, index) in rec.inscricao.avaliacaos" :key="index">
							<td>
								<a v-if='!avaliacao.invalido && !avaliacao.impedido' :href="'/avaliacoes-aval/' + avaliacao.id" target='_blank'>
									Avaliação {{index + 1}}
								</a>
								<a v-else disabled style="color: gray;">
									Avaliação {{index + 1}}*
								</a>
							</td>
							<!--td>
								<a :href="'/usuario/' + avaliacao.user.id" target='_blank'>
									{{avaliacao.user.name}}
								</a>
							</td-->
						</tr>
					</tbody>
				</table>
			<!--/center-->
		</template>

		<br>
		<h5>Itens do Recurso</h5>
		<template v-for='(recItem, indexRec) in recItens'>
			<div class="row">
				<div class="input-field col s12 m12 l12 x12">
					<label>Item do Recurso</label>
				</div>
			</div>
			<div class="row">
				<div class="input-field col s12 m12 l12 x12">
					<template v-for="item in itens">
						<template v-if="item.id == recItem.aval_item_id && item.plano_id == recItem.planos_de_trabalho_id">
							{{ item.nome }}
						</template>
					</template>
				</div>
			</div>
			<div class="row">
				<div class="input-field col s12 m2 l2 x2">
					<label>Avaliador</label>
				</div>
				<div class="input-field col s12 m2 l2 x2">
					<label>Deferido?</label>
				</div>
				<div v-if="recItem.deferido == 'true'" class="input-field col s12 m2 l2 x2">
					<label>Nova nota</label>
				</div>
			</div>
			<div class="row">
				<div class="input-field col s12 m2 l2 x2">
					<template v-for="(avaliacao, indexAval) in rec.inscricao.avaliacaos">
						<template v-if="avaliacao.id == recItem.avaliacao_id">
							Avaliador {{ indexAval + 1 }}
						</template>
					</template>
				</div>
				<div class="input-field col s12 m2 l2 x2">
					<select v-model="recItem.deferido" class="browser-default select_sec" :disabled='rec.deferido !== null'>
						<option selected disabled value=null>Selecione</option>
						<option value=false>Não</option>
						<option value=true>Sim</option>
					</select>
				</div> 
				<div v-if="recItem.deferido == 'true' || recItem.deferido === true" class="input-field col s12 m2 l2 x2">
					<input type="number" v-model="recItem.nota" :min="recItem.nota_min" :max="recItem.nota_max" :step="recItem.nota_var" class='validate' :readonly='rec.deferido !== null'>
				</div>
			</div>
		<hr>
		</template>	
			
		<div class="row">
			<div class="input-field col s12 m12 12 x12">
				<label>Texto do pedido de Recurso</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m12 l12 x12">
				{{rec.texto}}
			</div>
		</div>

		<div class="row">
			<div class="input-field col s4 m4 l4 x4">
				<label>Recurso deferido?</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s2 m2 l2 x2">
				{{resultado()}}
			</div>
		</div>

		<div class="row">
			<div class="input-field col s12 m12 12 x12">
				<label>Justificativa da Análise do Recurso</label>
			</div>
			<div class="input-field col s12 m12 l12 x12">
				<!--p v-if='rec.deferido == "false" || rec.deferido == false'>{{reprovado_rec}}</p>
				<p v-if='rec.deferido == "true" || rec.deferido == true'>{{aprovado_rec}}</p-->
				<textarea name="justificativa" id="justificativa" required v-model="rec.justificativa" class="materialize-textarea" :maxlength="caracteres" :data-length="caracteres" :readonly='rec.deferido !== null'></textarea>
			</div>
		</div>

		<center v-if='rec.deferido === null'>
			<div class="row">

				<div class="input-field col s6 m6 l6 xl6">
					<button class="btn" id='submit' @click.prevent="enviar">
						<i class="material-icons left">save</i>Salvar
					</button>
				</div>
				<div class="input-field col s6 m6 l6 xl6">
					<button type="button" class="btn indigo" @click="clear">
						<i class="material-icons right">clear</i>Limpar
					</button>
				</div>
			</div>
		</center>
	</div>
</template>

<script>
	import Loading from 'vue-loading-overlay';
	import 'vue-loading-overlay/dist/vue-loading.css';
    
    export default {
		name: "VueRecursosAvalAvalForm",
		components: {Loading},
		props: [
			'recurso',
			'aval_itens',
			'planos_trabalho',
			'aprovado_rec',
			'reprovado_rec',
			'caracteres',
            'estaEmPeriodoDeAnaliseDasExigenciasJson',
            'estaEmPeriodoDeAnaliseTecnicaJson',
            'usuarioECoordenadorDaAcaoJson'
		],
		data () {
			return {
				rec: JSON.parse(this.recurso),
				itens: JSON.parse(this.aval_itens),
                estaEmPeriodoDeAnaliseDasExigencias : !(!this.estaEmPeriodoDeAnaliseDasExigenciasJson || this.estaEmPeriodoDeAnaliseDasExigenciasJson === 'false' || this.estaEmPeriodoDeAnaliseDasExigenciasJson === ''),
                estaEmPeriodoDeAnaliseTecnica: !(!this.estaEmPeriodoDeAnaliseTecnicaJson || this.estaEmPeriodoDeAnaliseTecnicaJson === 'false' || this.estaEmPeriodoDeAnaliseTecnicaJson === ''),
                usuarioECoordenadorDaAcao: !(!this.usuarioECoordenadorDaAcaoJson || this.usuarioECoordenadorDaAcaoJson === 'false' || this.usuarioECoordenadorDaAcaoJson === ''),
				planos: JSON.parse(this.planos_trabalho),
				recItens: JSON.parse(this.recurso).recurso_items,
				deferido: null,
				loading: false
			}
		},
		methods: {
			clear (ev) {
				this.rec.deferido = null;
				this.rec.justificativa = '';
			},

            retornaSeInscricaoEstaHabilitadaParaTerAnaliseTecnicaEditada(){
                return (!this.usuarioECoordenadorDaAcao && this.estaEmPeriodoDeAnaliseTecnica)
            },
			inicializaTela() {
				var itens = this.itens,
				planos = this.planos,
				numPlanos = planos.length,
				numItens = itens.length,
				item,
				i = -1,
				j;
		
				while (++i < numItens) {
					if (itens[i].campo_referente_na_inscricao == 'planos_de_trabalho') {
						j = 0;
						while (++j <= numPlanos) {
							item = structuredClone(itens[i]);
							item.nome = 'Plano ' + j + '- ' + item.nome;
							item.plano_id = planos[j - 1].id;
							itens.push(item);
							
						}
						itens.splice(i--, 1);
						numItens--;
					} else
						itens[i].plano_id = null;
				}
			},
			resultado() {
				var recItens = this.recItens,
					i = recItens.length,
					deferido = false,
					indeferido = false,
					vazio = false;
				
				while (--i >= 0) {
					if (recItens[i].deferido == 'true' || recItens[i].deferido === true)
						deferido = true;
					else if (recItens[i].deferido == 'false' || recItens[i].deferido === false)
						indeferido = true;
					else
					    vazio = true;
				}
				
				if (vazio) {
					this.deferido = null;
					return null;
				} else if (deferido && !indeferido) {
					this.deferido = 1;
					return 'Sim';
				} else if (!deferido && indeferido) {
					this.deferido = 0;
					return 'Não';
				} else if (deferido && indeferido) {
					this.deferido = 2;
					return 'Parcialmente';
				}
			},
			async enviar() {
				var confirmaEnvio = true;

				await Swal.fire({
					title: 'Tem certeza que deseja submeter a avaliação recurso?',
					text: "Após o envio não será mais possível editá-lo!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Sim, pode enviar!',
					cancelButtonText: 'Cancelar.'
				}).then((result) => {
					confirmaEnvio = result.isConfirmed
				})

				if (confirmaEnvio) {
					var recItens = this.recItens,
						i = recItens.length, 
						recItem;
					
					if (!this.rec.justificativa || !this.rec.justificativa.trim().length) {
						Swal.fire({ title: 'Ação inválida!', text: 'É necessário informar uma justificativa para o resultado da avaliação do recurso!', icon: 'error'});
						return;
					}
				
					while (--i >= 0) {
						if (!(recItem = recItens[i]).deferido) { 
							Swal.fire({ title: 'Ação inválida!', text: 'É necessário avaliar todos os itens do recurso!', icon: 'error'});
							return;
						} else if ((recItem.deferido == 'true' || recItem.deferido === true) && Number(recItem.nota) <= Number(recItem.nota_min)) {
							Swal.fire({ title: 'Ação inválida!', text: 'Se um item de recurso for deferido, sua nota deve ser maior do que a nota original!', icon: 'error'});
							return;
						} else if ((recItem.deferido == 'true' || recItem.deferido === true) && Number(recItem.nota) > Number(recItem.nota_max)) {
							Swal.fire({ title: 'Ação inválida!', text: 'A nova nota de um item de recurso não pode ser maior do que a nota máxima!', icon: 'error'});
							return;
						}
						
					}
						
					this.loading = true;
					this.rec.deferido = this.deferido;

					await this.$http.post('/api/recursos-aval/' + this.rec.id, {
						recurso: this.rec,
						itens: this.recItens
					}
					).then(response => {
						window.location.href = `/recursos-aval/?msg=${response.body.msg}`
					}, error => {
						Swal.fire({ title: 'Ocorreu um erro!', text: error.body.msg, footer: error.body.exception, icon: 'error'});
					})

					this.loading = false;
				}
			}
		},
		mounted() {
			this.inicializaTela();
			$("#justificativa").characterCounter();
		}
	}
</script>